import "core-js/modules/es6.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _defineProperty from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import cookie from '@tencent/vft-common/cookie';
import logger from '@tencent/vft-common/logger';
import { globalObject } from '@tencent/vft-common/system';
import { loadScript } from '@tencent/vft-common/util.esm';
var loadPromise = null;
// wiki: https://mirrors.tencent.com/#/private/npm/detail?repo_id=537&project_name=%40tencent%2Fqimeisdk-web
export var Sign = /*#__PURE__*/function () {
  function Sign() {
    _classCallCheck(this, Sign);
    _defineProperty(this, "sdk", null);
  }
  _createClass(Sign, [{
    key: "getWebInstance",
    value: function () {
      var _getWebInstance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var QimeiWebLite;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.sdk) {
                  _context.next = 5;
                  break;
                }
                _context.next = 3;
                return this.loadQimeiSDK();
              case 3:
                QimeiWebLite = _context.sent;
                this.sdk = new QimeiWebLite({
                  appKey: '15d45fa36b498329'
                });
              case 5:
                return _context.abrupt("return", this.sdk);
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getWebInstance() {
        return _getWebInstance.apply(this, arguments);
      }
      return getWebInstance;
    }()
  }, {
    key: "loadQimeiSDK",
    value: function () {
      var _loadQimeiSDK = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (globalObject.QimeiWebLite) {
                  _context2.next = 4;
                  break;
                }
                // report和login同时调用 getWebInstance的时候会同时load2次script
                loadPromise = loadPromise || loadScript('https://staticfile.qq.com/sec_platform/sdk-web/0.5/lite.js', {
                  timeout: 2500
                }).catch(function () {
                  loadPromise = null;
                });
                _context2.next = 4;
                return loadPromise;
              case 4:
                return _context2.abrupt("return", globalObject.QimeiWebLite);
              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      function loadQimeiSDK() {
        return _loadQimeiSDK.apply(this, arguments);
      }
      return loadQimeiSDK;
    }()
  }, {
    key: "fetchSDKQimei36",
    value: function () {
      var _fetchSDKQimei = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var sdk;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.getWebInstance();
              case 3:
                sdk = _context3.sent;
                return _context3.abrupt("return", sdk.getLocalQimei36());
              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                logger.error('getLocalQimei36 error', _context3.t0);
                return _context3.abrupt("return", {
                  q36: '',
                  h38: ''
                });
              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));
      function fetchSDKQimei36() {
        return _fetchSDKQimei.apply(this, arguments);
      }
      return fetchSDKQimei36;
    }() /**
         * 获取Qimei36
         * 优先从 cookie 中的字段 vdevice_qimei36 取值，取不到则从 h5-qimei-sdk 取
         * @param {Boolean} useCookie 是否强制从 cookie 取
         * @returns
         */
  }, {
    key: "getQimei36",
    value: function () {
      var _getQimei = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var useCookie,
          qimei36,
          _yield$this$fetchSDKQ,
          q36,
          _args4 = arguments;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                useCookie = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : false;
                qimei36 = cookie.get('vdevice_qimei36') || '';
                if (!useCookie) {
                  _context4.next = 4;
                  break;
                }
                return _context4.abrupt("return", qimei36);
              case 4:
                if (!qimei36) {
                  _context4.next = 6;
                  break;
                }
                return _context4.abrupt("return", qimei36);
              case 6:
                _context4.next = 8;
                return this.fetchSDKQimei36();
              case 8:
                _yield$this$fetchSDKQ = _context4.sent;
                q36 = _yield$this$fetchSDKQ.q36;
                return _context4.abrupt("return", q36);
              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function getQimei36() {
        return _getQimei.apply(this, arguments);
      }
      return getQimei36;
    }() /**
         * 获取h38
         * @returns {String}
         */
  }, {
    key: "getH38",
    value: function () {
      var _getH = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _yield$this$fetchSDKQ2, h38;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.fetchSDKQimei36();
              case 2:
                _yield$this$fetchSDKQ2 = _context5.sent;
                h38 = _yield$this$fetchSDKQ2.h38;
                return _context5.abrupt("return", h38);
              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function getH38() {
        return _getH.apply(this, arguments);
      }
      return getH38;
    }() /**
         * 获取签名信息
         * @returns {Object}
         */
  }, {
    key: "getSignInfo",
    value: function () {
      var _getSignInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _yield$this$fetchSDKQ3, q36, h38, ts, guid, signOriginValue, signResult, sdk;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.fetchSDKQimei36();
              case 2:
                _yield$this$fetchSDKQ3 = _context6.sent;
                q36 = _yield$this$fetchSDKQ3.q36;
                h38 = _yield$this$fetchSDKQ3.h38;
                // 签名原始信息
                ts = Date.now();
                guid = cookie.get('video_guid');
                signOriginValue = "g=".concat(guid, "&t=").concat(ts, "&r=").concat(Math.random().toString(36).slice(2));
                signResult = '';
                _context6.prev = 9;
                _context6.next = 12;
                return this.getWebInstance();
              case 12:
                sdk = _context6.sent;
                _context6.next = 15;
                return sdk.sign(signOriginValue, ts);
              case 15:
                signResult = _context6.sent;
                _context6.next = 21;
                break;
              case 18:
                _context6.prev = 18;
                _context6.t0 = _context6["catch"](9);
                logger.error('qimeiWebSdk.sign fail: ', _context6.t0);
              case 21:
                return _context6.abrupt("return", {
                  q36: q36,
                  h38: h38,
                  o_data: signOriginValue,
                  // 原始数据 g={guid}&t={时间戳}&r={随机字符串}
                  s: signResult // 加密后的密文
                });
              case 22:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[9, 18]]);
      }));
      function getSignInfo() {
        return _getSignInfo.apply(this, arguments);
      }
      return getSignInfo;
    }()
  }]);
  return Sign;
}();
export default new Sign();